import PreOperations from '@domains/pre-operations/views/PreOperations.vue'

export default [
  {
    path: 'pre-operations',
    component: PreOperations,
    name: 'PreOperations',
    props: (route) => ({
      search: route.query.search,
      status: route.query.status,
      type: route.query.type,
      createdAt: route.query.createdAt,
      id: route.query.id
    })
  }
]
